import React, {Dispatch, SetStateAction, useEffect, useRef, useState} from "react";
import {COMMON_MODAL_STYLE} from "../../../helper/StyleHelper";
import {Col, Modal, Row, Table} from "react-bootstrap";
import {IoMdClose} from "react-icons/io";
import Datatables, {getCheckedItems} from "../../component/Datatables";
import axios from "axios";
import {toast} from "react-toastify";
import messageCodeDic from "../../../util/messageCodeDic";
import BMCSelect from "../../../components/common/BMCSelect";
import {getLoginUser} from "../../../helper/SecurityHelper";
import SHSearch from "../../component/BMCSearch";
import BMCInput from "../../../components/common/BMCInput";
import restapi from "../../../helper/restAPIHelper";
import SiteSftyChkRgstModal from "../../safetyWorkReportManagement/modal/SiteSftyChkRgstModal";
import FcltySftyChkModal from "../../fclty/modal/FcltySftyChkModal";

interface IProps {
    setModalIsOpen: Dispatch<SetStateAction<boolean>>;
    modalIsOpen: boolean;
    dataList: object[];
    prcsStatCd?: string;
    sftyChkDt?: string;
    title?: string;

}

const $ = require("jquery")

const FcltySftyChkInfoListModal = (props: IProps) => {
    const [datatable, setDatatable] = useState<any>();

    const [isCodeDataLoaded, setIsCodeDataLoaded] = useState<any>(null);
    const searchFormRef = useRef<any>();
    const [dataList, setDataList] = useState<any>([]);
    const [orgnDataList, setOrgnDataList] = useState<any>([]);
    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    const [detailData, setDetailData] = useState(null);

    useEffect(() => {
        if (isCodeDataLoaded) {
            fn_search();
        }
    }, [isCodeDataLoaded]);

    function fn_closeModal() {
        props.setModalIsOpen(false);
    }

    const fn_search = (e?: any) => {
        e?.preventDefault()
        datatable?.draw()
    }

    const fn_onShow = () => {

        let cstmDataList = [];

        if(props.prcsStatCd){
            cstmDataList = props.dataList.filter((data: any) => (data.prcsStatCd == props.prcsStatCd))
        }else{
            cstmDataList = props.dataList
        }

        setDataList(cstmDataList);

        setOrgnDataList(props.dataList);
    }

    const fn_retrieveDataList = () => {
        const obj = new FormData(searchFormRef.current);
        const prcsStatCd = obj.get('prcsStatC');

        let cstmDataList = [];

        cstmDataList = orgnDataList.filter((data: any) => {
            let isValid = true;

            if (prcsStatCd) {
                if (data.prcsStatCd != prcsStatCd) {
                    isValid = false;
                }
            }
            return isValid;
        })

        setDataList(cstmDataList);

    }

    return (
        <div>
            <FcltySftyChkModal setModalIsOpen={setModalIsOpen} modalIsOpen={modalIsOpen} detailData={detailData}/>

            <Modal
                className="bmc-modal" size="xl"
                show={props.modalIsOpen}
                onShow={() => {
                    fn_onShow()

                }}
                onHide={fn_closeModal}
            >


                <Modal.Header>
                    <div className="d-flex justify-content-between align-items-center w-100 bmc-font-SD">
                        {props.title? props.title : '안전점검 대상 목록'}{props.sftyChkDt && '[' + props.sftyChkDt + ']'}
                        <IoMdClose className='hover:cursor-pointer' onClick={fn_closeModal}/>
                    </div>
                </Modal.Header>

                <Modal.Body className="px-4">

                    <div className={'ge-result'}>
                        <Datatables
                            datas={dataList}
                            scrollY="550px"
                            className="bmc-fs-b4"
                            parameterFormRef={searchFormRef}
                            columns={[
                                {data: "sftyDgnsGbNm", title: "구분"},
                                {data: "efctDt", title: "시행일"},
                                {data: "budget", title: '예산', render: function (data: any) {
                                        return data?.toLocaleString() + ' (천원)';
                                    }},
                                {data: 'sftyChkRsltRgstrNm', title: '점검자'}
                            ]}
                            checked={false}
                            onLoad={(dt: any) => {
                                setDatatable(dt)
                            }}

                            onClick={(data) => {
                                setDetailData(data)
                                setModalIsOpen(true);
                            }
                            }
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="py-2">
                    <div className='flex justify-center w-100'>
                        <button
                            className='bmc-btn pill l white me-3'
                            onClick={fn_closeModal}>닫기
                        </button>

                    </div>
                </Modal.Footer>


            </Modal>
        </div>
    )
}

export default FcltySftyChkInfoListModal;
